module.exports = __webpack_public_path__ + "img/cricket.5ca514df.svg";